export const IS_PROD =
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) ===
    'production';
export const IS_NON_PROD =
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) !==
    'production';
export const IS_DEV =
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) ===
    'development';
export const REGISTER_LINK =
    window?.process?.env?.REGISTER_URL ?? process.env.REGISTER_URL;
export const SIGNUP_LINK =
    window?.process?.env?.SIGNUP_URL ?? process.env.SIGNUP_URL;
export const TDOC_AUTH_TOKEN = 'member_auth_token';
/** PLI / WebSDK bundle cookie; keep aligned with OneApp `BUNDLE_IDENTIFIER`. */
export const BUNDLE_IDENTIFIER = 'bundle_identifier';
export const MEAL_TYPE = 'meal_type';
export const MEAL_ID = 'meal_id';
export const FOOD_UI = 'food_ui';
export const CACHED_DATA_MINUTES_TTL = 5;
export const DATA_LOAD_EXPIRATION = 'data_load_expiration';
export const INITIAL_DATA_LOAD = 'initial_data_load';
export const ONEAPP_HOME_PATH = '/';
export const MEDOPT_SIGNUP = 'medopt-signup';
export const MEDOPT_WM_DPP_SIGNUP = 'condition-care-WM-DPP-signup';
export const MY_REFRESH_COOKIE = 'my_refreshToken';
export const ACCESS_TOKEN_COOKIE = 'access_token';
export const REFRESH_TOKEN_COOKIE = 'refresh_token';
export const EDUCATION_TOKEN_COOKIE = 'education-token';
export const FOOD_TOUR_KEY = 'has-seen-food-tour';
export const NEXT_COACHING_SESSION = 'next-coaching-session';
export const COACH_SESSION = 'coach-session';
export const SEND_MESSAGE_ONCE = 'send-message-once';
export const ONBOARDING_INTRO_SEEN = 'has-seen-onboarding-intro';
export const ACHIEVED_WEIGHT_COOKIE = 'has-seen-achieved-weight';
export const HF_RETAKE_ALERT_ID = 'retake-alert-id';
export const MEMBER_ID = 'member_id';
export const MEMBER_ID_PREV = 'member_id_prev';
export const IMPERSONATION = 'impersonation';
export const ACTIVE_PROVIDER_GROUP_ID = 'group_id';
export const STORED_PROVIDER_GROUP_ID = 'stored_group_id';
export const HF_RETAKE_REACHOUT_NOT_NEEDED_KEY =
    'has-seen-retake-reachout-not-needed-card';
export const HF_RETAKE_LINK_TIMED_OUT_KEY = 'has-seen-retake-link-timeout';
export const SUMMARY_REPORTS_CLICK = 'summaryReportsClick';
export const FOOD_LOG_MULTI_ITEM_FOOD_VIEW = 'foodLogMultiItemFoodView';
export const FOOD_LOG_SINGLE_ITEM_FOOD_VIEW = 'foodLogSingleItemFoodView';
export const FOOD_LOG_SAVE_CLICK = 'foodLogSaveClick';
export const FOOD_LOG_SAVE_SUCCESS_VIEW = 'foodLogSaveSuccessView';
export const FOOD_LOG_NUTRITION_EDIT_CLICK = 'foodLogNutritionEditClick';
export const FOOD_LOG_EDIT_FOOD_VIEW = 'foodLogEditFoodView';
export const FOOD_LOG_SERVING_UNIT_CLICK = 'foodLogServingUnitClick';
export const FOOD_LOG_NUTRITION_INFO_CLICK = 'foodLogNutritionInfoClick';
export const FOOD_LOG_EDIT_FOOD_CANCEL_CLICK = 'foodLogEditFoodCancelClick';
export const FOOD_LOG_EDIT_FOOD_SAVE_CLICK = 'foodLogEditFoodSaveClick';
export const SHARE_SUMMARY_REPORT_CANCEL_CLICK =
    'shareSummaryReportCancelClick';
export const USER_LOCALE_COOKIE = 'user_preferred_language';
export const LANGUAGE_MODAL_KEY = 'has-seen-language-modal';
export const NEXT_GEN_WEIGHT_DEVICE = 'wm2000';
export const UTM_PARAMETERS = 'utm_parameters';
export const KEYCLOAK_URI = 'keycloak_uri';
export const A1C = 'HbA1C';
export const CHOLESTEROL = 'Cholesterol';
export const A1C_AND_CHOLESTEROL = 'a1c-and-cholesterol';
export const BODY_COMPOSITION_ID = 'bodyComposition';
export const MEMBER_COMMUNICATION_POLICY = {
    'en-US':
        'https://content.livongo.com/docs/Livongo_Member_Communication_Policy.pdf',
    'es-US':
        'https://content.livongo.com/docs/Livongo_Member_Communication_Policy.pdf',
    // TODO: update to Spanish Member Communication Policy once it's translated
};
export const MEMBER_SUPPORT_EMAIL = 'membersupport@livongo.com';
export const ONEAPP_SUPPORT_EMAIL = 'membersupport@teladochealth.com';
export const INTRO_DPP_VIDEO_URL = {
    'en-US': `https://www.teladochealth.com/helpcenter/article/introduction-to-the-diabetes-prevention-program`,
    'es-US': `https://www.teladochealth.com/es-us/helpcenter/article/introduction-to-the-diabetes-prevention-program`,
};
export const INTRO_DM_VIDEO_URL = {
    'en-US': `https://www.teladochealth.com/library/article/jumpstart-your-diabetes-management-program-video`,
    'es-US': `https://www.teladochealth.com/es-us/library/article/jumpstart-your-diabetes-management-program-video`,
};
export const INTRO_DM_VIDEO_URL_NEXT_GEN = {
    'en-US':
        'https://www.teladochealth.com/library/article/welcome-to-teladoc-healths-diabetes-management-program',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/welcome-to-teladoc-healths-diabetes-management-program',
};
export const INTRO_HTN_VIDEO_URL = {
    'en-US': `https://www.teladochealth.com/library/article/introduction-to-hypertension-management-pro-tips`,
    'es-US': `https://www.teladochealth.com/es-us/library/article/introduction-to-hypertension-management-pro-tips`,
};
export const MEMBER_SUPPORT_URL = {
    'en-US': 'https://www.teladochealth.com/contact',
    'es-US': 'https://www.teladochealth.com/contact', // There is no Spanish version of this page
};
export const LIBRARY_URL = {
    'en-US': 'https://www.teladochealth.com/library',
    'es-US': 'https://www.teladochealth.com/es-us/library',
};
export const GLP1_ENGAGEMENT_FAQ_URL = {
    'en-US':
        'https://www.teladochealth.com/helpcenter/article/glp-1-engagement-requirements-faqs',
    'es-US':
        'https://www.teladochealth.com/es-us/helpcenter/article/glp-1-engagement-requirements-faqs',
};
export const GLP1_ELIGIBILITY_COVERAGE_URL = {
    'en-US':
        'https://www.teladochealth.com/helpcenter/article/glp-1-medications-for-weight-loss-eligibility-and-coverage',
    'es-US':
        'https://www.teladochealth.com/es-us/helpcenter/article/glp-1-medications-for-weight-loss-eligibility-and-coverage',
};
export const GLP1_COSTS_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/manage-the-cost-of-glp-1-drugs-through-our-discounted-self-pay-option',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/manage-the-cost-of-glp-1-drugs-through-our-discounted-self-pay-option',
};
export const TWILIO_SMS_PHONE_NUMBER = '844-981-4079';
export const IOS_APP_LINK = 'https://apps.apple.com/us/app/livongo/id991595088';
export const ANDROID_APP_LINK =
    'https://play.google.com/store/apps/details?id=com.livongo.lvmobility&hl=en_US';
export const IOS_ONEAPP_LINK =
    'https://apps.apple.com/us/app/teladoc-telehealth-therapy/id656872607';
export const ANDROID_ONEAPP_LINK =
    'https://play.google.com/store/apps/details?id=com.teladoc.members&hl=en_US&gl=US';
export const TERMS_OF_SERVICE_URL = {
    'en-US': `https://www.teladochealth.com/legal/terms-of-service`,
    'es-US': `https://www.teladochealth.com/es-us/legal/terms-of-service`,
};
export const PRIVACY_POLICY_URL = {
    'en-US': `https://www.teladochealth.com/legal/privacy-policy`,
    'es-US': `https://www.teladochealth.com/es-us/legal/privacy-policy`,
    // TODO: Uncomment spanish privacy policy link after document is updated at the end of q1 2021
    // es: 'https://teladochealth.com/es/privacy-policy/',
};
export const CONSENT_AGREEMENT_URL =
    'https://www.teladoc.com/informed-consent-agreement';
export const PRIVACY_PRACTICES_URL = {
    'en-US': `https://www.teladochealth.com/legal/notice-of-privacy-practices`,
    'es-US': `https://www.teladochealth.com/es-us/legal/notice-of-privacy-practices`,
};
export const COPA_PRIVACY_URL = `https://content.teladochealth.com/docs/childrens-online-privacy.html`;
export const ARTICLES = {
    'en-US': {
        wm1000: 'https://www.teladochealth.com/helpcenter/article/how-to-use-your-teladoc-health-wm1000-weight-scale',
        wm1500: 'https://www.teladochealth.com/helpcenter/article/how-to-weigh-in-with-the-teladoc-health-wm1500-weight-scale',
    },
    'es-US': {
        wm1000: 'https://www.teladochealth.com/es-us/helpcenter/article/how-to-use-your-teladoc-health-wm1000-weight-scale',
        wm1500: 'https://www.teladochealth.com/es-us/helpcenter/article/how-to-weigh-in-with-the-teladoc-health-wm1500-weight-scale',
    },
};
export const BLOOD_GULCOSE_METER_URL = {
    'en-US':
        'https://www.teladochealth.com/helpcenter/article/how-to-check-your-blood-sugar-with-your-blood-glucose-meter',
    'es-US':
        'https://www.teladochealth.com/es-us/helpcenter/article/how-to-check-your-blood-sugar-with-your-blood-glucose-meter',
};
export const A1C_GUIDE_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/your-guide-to-lowering-your-a1c',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/your-guide-to-lowering-your-a1c',
};
export const BP_GUIDE_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/understanding-and-managing-high-blood-pressure',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/understanding-and-managing-high-blood-pressure',
};
export const HEART_RATE_URL = {
    'en-US':
        'https://www.teladochealth.com/library/article/getting-to-know-your-heart-rate',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/getting-to-know-your-heart-rate',
};
export const NAME_INPUT_PATTERN = "^(?![- '.]+$)[-0-9A-zÀ-ž '.]*$"; // https://regex101.com/r/1D9Myt/97
export const ADDRESS_INPUT_PATTERN = '[-.0-9A-zÀ-ž #]+';
export const EMAIL_INPUT_MAX_LENGTH = 100;
export const EMAIL_INPUT_PATTERN =
    '^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$';
export const CONFETTI_COLORS = [
    '#0060FC',
    '#36D663',
    '#86D5DF',
    '#66B5F7',
    '#E80048',
    '#34A847',
    '#E47600',
    '#845EF7',
    '#149DB1',
];
export const PHONE_INPUT_PATTERN =
    '^[(]?([0-9]{3})[)]?([-. ])?([0-9]{3})([-. ])?([0-9]{4})$';
export const FORMAT_DATETIME_NO_TZ = "yyyy-MM-dd'T'HH:mm:ss";
export const REFERRER_REGEX = /^https:\/\/(\w*\.)*livongo\.com\//;
export const BANNER_LAUNCH_DATE = {month: 4, day: 15};
export const BANNER_EXPIRY_DATE = {month: 5, day: 30};
export const NON_DISCRIMINATION_URL = {
    'en-US': `https://www.teladochealth.com/legal/notice-of-non-discrimination`,
    'es-US': `https://www.teladochealth.com/es-us/legal/notice-of-non-discrimination`,
};
export const CONDITION_MANAGEMENT_HOMEPATH = '/condition-management/home';
export const CONDITION_MANAGEMENT_YOURPROGRAMSPATH =
    '/condition-management/programs';
export const BP_USING_YOUR_MONITOR = '/blood-pressure/using-your-monitor';
export const WEIGHT_GET_STARTED = '/weight/get-started';
export const ONEAPP_BP_USING_YOUR_MONITOR =
    '/condition-management/blood-pressure/using-your-monitor';
export const ONEAPP_WEIGHT_GET_STARTED =
    '/condition-management/weight/get-started';
export const ONEAPP_PROFILE_SETTINGS_PATH = '/account/profile';
export const EDUCATION_SOURCE_PARAM = '&source=member-portal';
export const FOOD_INSIGHTS_PATH = '/food/overview'; // Food Insights features
export const MEMBER_SUPPORT_PHONE_NUMBER = '1-800-835-2352';
export const LIVONGO_HOME_PAGE = 'https://www.livongo.com/';
export const CHOOSE_LIVONGO_HOME = 'https://choose.livongo.com';
export const DEXCOM_AUTH_URL = 'https://api.dexcom.com/v2/oauth2/login';
export const ABBOTT_AUTH_URL =
    'https://oauth.partner.int.adc-lv.io/oauth2/auth';
export const STAGES_OF_KIDNEY_DISEASE_LINK = {
    'en-US':
        'https://www.teladochealth.com/library/article/kidney-health-basics-stages-of-kidney-disease',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/kidney-health-basics-stages-of-kidney-disease',
};
export const UNDERSTANDING_KIDNEY_RESULTS_LINK = {
    'en-US':
        'https://www.teladochealth.com/library/article/kidney-health-basics-understanding-your-results',
    'es-US':
        'https://www.teladochealth.com/es-us/library/article/kidney-health-basics-understanding-your-results',
};
export const MANAGING_CHRONIC_KIDNEY_DISEASE = {
    'en-US': 'https://www.teladochealth.com/library/kidney-health',
    'es-US': 'https://www.teladochealth.com/es-us/library/kidney-health',
};
export const CARDIOMETABOLIC_AT_HOME_TEST = {
    'en-US': `https://www.teladochealth.com/library/article/teladoc-health-at-home-test-program`,
    'es-US': `https://www.teladochealth.com/es-us/library/article/teladoc-health-at-home-test-program`,
};
export const TEAMS_APP_ID_URL = 'https://teams.microsoft.com/l/entity';
export const DESKTOP_SCREEN_SIZE = 1025;
export const MOBILE_SCREEN_SIZE = 767;
export const FEATURE_FLAG_NAMES = {
    mhWebsdk: 'enable_mh_websdk',
    onboarding: 'enable_onboarding',
    cgm: 'enable_cgm',
    enableMultiBenefits: 'enable_multi_benefits',
    inAppEngagement: 'enable_glp1_engagement',
    mhPlanImpersonation: 'enable_mh_plan_impersonation',
    enableAxleCancelAPI: 'enable_axle_cancel_api',
};
export const EVENT_PROPS = {
    Global: 'Global',
    Languages: 'Languages',
    LanguageOptions: {
        'en-US': 'English',
        'es-US': 'Spanish',
    },
};
export const HEALTH_EQUITY_FIELDS = [
    'race',
    'sexualOrientation',
    'genderIdentity',
    'pronouns',
];
export const CORE_PROGRAMS = {
    DM: 'DIABETES',
    HTN: 'HYPERTENSION',
    WM: 'WEIGHT_MANAGEMENT',
    DPP: 'PREDIABETES',
    BH: 'BEHAVIORAL_HEALTH',
    CKD: 'CHRONIC_KIDNEY_DISEASE',
    HF: 'HEART_FAILURE',
    DF: 'DIABETES_DEVICEFLEX',
};

export const RACE = 'race';
export const PRONOUNS = 'pronouns';
export const GENDER_IDENTITY = 'genderIdentity';
export const SEXUAL_ORIENTATION = 'sexualOrientation';
export const DK = 'DK';
export const PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY';
export const PROGRAM_MATERIALS_EMAIL = 'optIn';
export const PROGRAM_MATERIALS_SMS = 'smsOptOut';
export const sessionUUID = 'session_uuid';
export const YOUR_KEY = 'yours';
export const NETWORK_STATUS = 'networkStatus';
export const TOKEN_INVALID = 'tokenInvalid';
export const AVAILABLE_KEY = 'available';
export const BEHAVIORAL_HEALTH_SLUG = 'behavioralHealth';
export const REMINDER_FREQUENCY = [
    {name: 'DAY', checked: true},
    {name: 'WEEK', checked: false},
    {name: 'MONTH', checked: false},
];
export const DAYS_OF_THE_WEEK = [
    {name: 'SUNDAY', checked: true},
    {name: 'MONDAY', checked: true},
    {name: 'TUESDAY', checked: true},
    {name: 'WEDNESDAY', checked: true},
    {name: 'THURSDAY', checked: true},
    {name: 'FRIDAY', checked: true},
    {name: 'SATURDAY', checked: true},
];
export const DELIVERY_METHODS = {
    sms: 'SMS',
    pushNotification: 'PUSH_NOTIFICATION',
};
export const CONSENT_STATUS = {
    prompt: 'PROMPT',
    in: 'IN',
    out: 'OUT',
};

export const BREAKPOINT_SIZE = {
    Large: 'lg',
    Medium: 'md',
    Small: 'sm',
};
export const MIXPANEL_PRODUCT = 'Chronic Condition Management';
export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export const WEEKDAY = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];

export const APPTENTIVE_EVENTS = [
    'apptentive:survey:launch',
    'apptentive:note:launch',
    'apptentive:message-center:launch',
    'apptentive:love-dialog:launch',
];

export const COACHING_TYPES = {
    INVALID: 0,
    INTRO: 1,
    FOLLOW_UP: 2,
    OTHER: 3,
    INITIAL: 4,
};
export const COACHING_METHODS = {
    INVALID: 0,
    PHONE: 1,
    VIDEO: 2,
    OTHER: 3,
};

export const TIMEZONES = {
    US: [
        {
            abbreviation: 'HT',
            timeZoneCode: 'US/Hawaii',
            timeZoneDesc: 'US/Hawaii',
            timeZoneId: 368,
            longName: 'Hawaii-Aleutian Daylight Time',
        },
        {
            abbreviation: 'AK',
            timeZoneCode: 'US/Alaska',
            timeZoneDesc: 'US/Alaska',
            timeZoneId: 362,
            longName: 'Alaska Daylight Time',
        },
        {
            abbreviation: 'PT',
            timeZoneCode: 'US/Pacific',
            timeZoneDesc: 'US/Pacific',
            timeZoneId: 372,
            longName: 'Pacific Daylight Time',
        },
        {
            abbreviation: 'MT',
            timeZoneCode: 'US/Mountain',
            timeZoneDesc: 'US/Mountain',
            timeZoneId: 371,
            longName: 'Mountain Daylight Time',
        },
        {
            abbreviation: 'CT',
            timeZoneCode: 'US/Central',
            timeZoneDesc: 'US/Central',
            timeZoneId: 365,
            longName: 'Central Daylight Time',
        },
        {
            abbreviation: 'ET',
            timeZoneCode: 'US/Eastern',
            timeZoneDesc: 'US/Eastern',
            timeZoneId: 367,
            longName: 'Eastern Daylight Time',
        },
    ],
};
export const CCM_EVENT_PROPS = {
    category: 'ccm dashboard',
    productLine: 'Chronic Condition Management',
    device: 'Teladoc Health weight scale',
    dateRange: '1 Month | 3 Months',
    coachingCategory: 'coaching',
    weightCategory: 'weight',
    foodLogCategory: 'food log',
    bgCategory: 'blood sugar',
    bpCategory: 'blood pressure',
    glp1Category: 'tasks',
    conditionProfileCategory: 'condition profile',
    yourPrograms: 'your programs',
    remindersCategory: 'reminders',
    bodyCompositionCategory: 'body composition',
    cardiometabolic: 'cardiometabolic health',
    ccmCategory: 'ccm',
    cgmCategory: 'continuous glucose monitor',
    cgmLocation: 'CCM homepage',
    teladocLocation: 'Teladoc homepage',
    cgmTasks: {
        sync: 'Sync your CGM',
        activateDevices: 'Activate devices',
    },
};
export const ERROR_TRACKING_COMPONENTS = {
    RecentWeight: 'RecentWeight',
    RecentBloodSugar: 'RecentBloodSugar',
    RecentBloodPressure: 'RecentBloodPressure',
    RecentA1c: 'RecentA1c',
    RecentFood: 'RecentFood',
    RecentBodyComposition: 'RecentBodyComposition',
    RecentPulse: 'RecentPulse',
    RecentKidneyHealth: 'RecentKidneyHealth',
    LaunchpadHomeCard: 'LaunchpadHomeCard',
    Curriculum: 'Curriculum',
    OneappRoot: 'Root',
    AvailablePrograms: 'Programs',
    AllTasks: 'AllTasks',
    HomepageNextSteps: 'HomepageNextSteps',
    BloodPressureWidget: 'BloodPressureWidget',
    BloodSugarWidget: 'BloodSugarWidget',
    BloodGlucoseWidget: 'BloodGlucoseWidget',
    WeightManagementWidget: 'WeightManagementWidget',
    FoodWidget: 'FoodWidget',
    FoodSearch: 'FoodSearch',
    TaskDetails: 'TaskDetails',
    FoodLogEntry: 'FoodLogEntry',
    NextStepsTask: 'NextStepsTask',
    FoodLogNutrition: 'FoodLogNutrition',
    ProgramSwitchModal: 'ProgramSwitchModal',
    CareGuideActivation: 'CareGuideActivation',
    HealthInsightsFocusArea: 'HealthInsightsFocusArea',
};

export const CGM_EVENT_NAMES = {
    GLUCOSE_DATA_VIEW: 'glucoseDataView',
    GLUCOSE_DATA_TIME_RANGE_CLICK: 'glucoseDataTimeRangeClick',
    GLUCOSE_DATA_DATE_SELECTOR_CLICK: 'glucoseDataDateSelectorClick',
    GLUCOSE_DATA_UNDERSTAND_THESE_NUMBERS_CLICK:
        'glucoseDataUnderstandTheseNumbersClick',
    GLUCOSE_DATA_CHART_TOOLTIP_CLICK: 'glucoseDataChartTooltipClick',
    GLUCOSE_DATA_INSIGHT_CARD_CLICK: 'glucoseDataInsightCardClick',
    GLUCOSE_DATA_DEVICE_AND_APPS_CARD_CLICK:
        'glucoseDataDeviceAndAppsCardClick',
    HEALTH_SUMMARY_REPORT_VIEW: 'healthSummaryReportView',
    HEALTH_SUMMARY_REPORT_EXPORT_CLICK: 'healthSummaryReportExportClick',
    CGM_SCREEN_VIEW: 'cgmScreenView',
    CGM_MOBILE_DOWNLOAD_CLICK: 'cgmMobileDownloadClick',
};

export const CCM_MULTI_BENEFITS_EVENT_NAMES = {
    CONFIRM_PROGRAM_SWITCH_VIEW: 'confirmProgramSwitchView',
    CONFIRM_PROGRAM_COVERAGE_VIEW: 'confirmProgramCoverageView',
    ERROR_VIEW: 'errorView',
    PROGRAMS_MENU_CLICK: 'programsMenuClick',
};

export const SCREEN_STATE = {
    bodyCompositionOn: 'full body composition',
    bodyCompositionOff: 'weight-only mode',
    enable: 'enable',
    disable: 'disable',
};

export const AMPLITUDE_CTA = {
    allData: 'All data',
    summaryReport: 'Summary report',
};

export const IMPERSONATOR_TYPES = {
    Admin: 'Admin',
    CallCenterRep: 'CallCenterRep',
};

export const WIDGET_AMPLI_PROPS = {
    home: 'homepage',
    BiometricDataCard: 'Biometric Data Card',
    BloodGlucose: 'Blood Glucose',
    Widget: 'widget',
    CardClick: 'Card click',
};

export const bgDeviceImageMap = {
    bg300: 'bg300_device_flex_eanaeq',
    bg500: 'bg500_kenmf5',
};

export const bpDeviceImageMap = {
    ht2000: 'ht2000_jjyj1t',
    htn: 'htn_bv0ixc',
    ht900: 'ht900_945_hhswlf',
    ht945: 'ht900_945_hhswlf',
};

export const weightDeviceImageMap = {
    wm2000: 'wm2000_n8ccpm',
    wm1500: 'wm1500_qmylsh',
    wm1000: 'wm1000_mn4vr7',
};

export const BG_DEVICES_WITH_FIRMWARE_UPDATE = ['bg300', 'bg500'];

export const CLIENT_ID_MS_TEAMS_BOT = 'ms-teams';
export const CLIENT_ID_SERVICE_TEAMS = 'service-teams-';
export const MY_IS_REDIRECT_FROM_TEAMS = 'redirect_from_teams';
export const BANNER_SEEN_KEY = 'hasSeenPrivacyBanner';
export const USER_GLP1_STATES = {
    INTRO: 'intro',
    TRACKER: 'tracker',
};

export const PASSIO_ICON_URL =
    'https://storage.googleapis.com/passio-prod-env-public-cdn-data/label-icons/';
export const NEXT_GEN_DEVICES_ORDER_TYPES = ['BG500WK', 'HT2000WK', 'WM2000WK'];
